import types from '../mutation-types';
import Vue from 'vue';
import campaignsFlow from '../../api/campaignsFlow';

export const state = {
  records: [],
  campaignFlowSelected: null,
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
    isEditing: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getCampaigns(_state){
    return _state.records;
  },
  getCampaignSelected(_state){
    return _state.campaignFlowSelected;
  }
};

export const actions = {
    async get({ commit }) {
        commit(types.SET_CAMPAIGN_FLOW_UI_FLAG, { isFetching: true });
        commit(types.CLEAN_CAMPAIGNS_FLOW);
        try {
        const { data } = await campaignsFlow.getAll();
        commit(types.SET_CAMPAIGNS_FLOW, data);
        } catch (error) {
        throw new Error(error);
        } finally {
        commit(types.SET_CAMPAIGN_FLOW_UI_FLAG, { isFetching: false });
        }
    },

    async delete({ commit }, id) {
      commit(types.SET_CAMPAIGN_FLOW_UI_FLAG, { isDeleting: true });
      try {
        await campaignsFlow.delete(id);
        commit(types.DELETE_CAMPAIGN_FLOW, id);
      } catch (error) {
        throw new Error(error);
      } finally {
        commit(types.SET_CAMPAIGN_FLOW_UI_FLAG, { isDeleting: false });
      }
    },

    setCampaign({ commit }, { campaign }) {
      commit(types.SET_CAMPAIGN_FLOW_SELECTED, campaign);
    },

    
    async create({ commit }, payload) {
      commit(types.SET_CAMPAIGN_FLOW_UI_FLAG, { isCreating: true });
      try {
        const { data } = await campaignsFlow.create(payload);
        commit(types.ADD_CAMPAIGN_FLOW, data);
        return data;
      } catch (error) {
        throw new Error(error);
      } finally {
        commit(types.SET_CAMPAIGN_FLOW_UI_FLAG, { isCreating: false });
      }
    },


  async update({ commit }, payload) {
    commit(types.SET_CAMPAIGN_FLOW_UI_FLAG, { isEditing: true });
    try {
      const { data } = await campaignsFlow.update(payload);
      commit(types.EDIT_CAMPAIGN_FLOW, data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CAMPAIGN_FLOW_UI_FLAG, { isEditing: false });
    }
  },
};

export const mutations = {
  [types.SET_CAMPAIGN_FLOW_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.CLEAN_CAMPAIGNS_FLOW](state) {
    state.records = [];
  },

  [types.SET_CAMPAIGNS_FLOW]($state, data) {
    $state.records = data;
  },

  [types.SET_CAMPAIGN_FLOW_SELECTED]($state, data) {
    $state.campaignFlowSelected = data;
  },
  [types.DELETE_CAMPAIGN_FLOW]($state, id) {
    $state.records = $state.records.filter(campaign => campaign.id !== id);
  },

  [types.ADD_CAMPAIGN_FLOW]($state, data) {
    $state.records.push(data);
  },
  [types.EDIT_CAMPAIGN_FLOW](state, data) {
    const index = state.records.findIndex(activity => activity.id === data.id);
    if (index !== -1) {
      Vue.set(state.records, index, data);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
